import { gql } from "@apollo/client";
import moment from "moment";

export const GET_INDICACIONES_VISITA = gql`
query indicacionVisita($idEvaluacion: Int!) {
   indicacionVisita(idEvaluacion: $idEvaluacion){
      success
      valorEsperado{
        producto
        cantidad
        unidad
      }
    }
}`;